import { $$, store, emit, reducedMotion } from './env';

// data-theme đã được script inline trong <head> đặt TRƯỚC khi vẽ trang (không nháy màu); file này chỉ lo nút bấm.
const KEY = 'nth-theme';
const root = document.documentElement;

export const getTheme = () => (root.getAttribute('data-theme') === 'dark' ? 'dark' : 'light');

function apply(theme) {
  root.setAttribute('data-theme', theme);
  store.set(KEY, theme);
  $$('[data-theme-toggle]').forEach((btn) => btn.setAttribute('aria-pressed', String(theme === 'dark')));
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute('content', theme === 'dark' ? '#1d3131' : '#e5f1fb');
  emit('nth:theme', { theme });
}

function switchWithEffect(next, origin) {
  // View Transitions: ảnh chụp trang cũ/mới, theme mới loang tròn từ vị trí nút bấm
  if (!document.startViewTransition || reducedMotion.matches) {
    root.classList.add('is-theme-anim');
    apply(next);
    setTimeout(() => root.classList.remove('is-theme-anim'), 600);
    return;
  }
  const rect = origin.getBoundingClientRect();
  const x = rect.left + rect.width / 2;
  const y = rect.top + rect.height / 2;
  const r = Math.hypot(Math.max(x, innerWidth - x), Math.max(y, innerHeight - y));
  const vt = document.startViewTransition(() => apply(next));
  const timing = { duration: 700, easing: 'cubic-bezier(.65,0,.35,1)' };
  vt.ready.then(() => {
    document.documentElement.animate(
      { clipPath: [`circle(0px at ${x}px ${y}px)`, `circle(${r}px at ${x}px ${y}px)`] },
      { ...timing, pseudoElement: '::view-transition-new(root)' },
    );
    // viền sáng chạy theo mép vòng loang: vùng giống nhau ở 2 theme (header mobile theo PSD) vẫn thấy hiệu ứng lướt qua.
    // Gắn sau khi chụp ảnh trang cũ → chỉ hiện trong ảnh "sống" của trang mới, nằm sát mép trong của vòng tròn.
    const ring = document.createElement('div');
    ring.className = 'theme-ring';
    ring.style.cssText = `left:${x - r}px;top:${y - r}px;width:${r * 2}px;height:${r * 2}px`;
    document.body.appendChild(ring);
    ring.animate({ transform: ['scale(0)', 'scale(1)'], opacity: [1, 1, 0] }, timing);
    vt.finished.finally(() => ring.remove());
  }).catch(() => {});
}

export function initTheme() {
  $$('[data-theme-toggle]').forEach((btn) => {
    btn.setAttribute('aria-pressed', String(getTheme() === 'dark'));
    btn.addEventListener('click', () => switchWithEffect(getTheme() === 'dark' ? 'light' : 'dark', btn));
  });
}
